import React, {useEffect, useState} from 'react';
import Api from 'constants/Api';
import {getApiService} from 'redux/services/HttpService';
import {useSelector, useStore} from 'react-redux';
import {useRouter} from 'next/router'
import {wrapper} from 'redux/store';
import Cookies from 'js-cookie';
import {PersistGate} from 'redux-persist/integration/react';
import {ThemeSwitcherProvider} from 'react-css-theme-switcher';
import RequirementSystem from 'components/RequirementSystem';
import Head from 'next/head';
import AppLayout from 'components/layout/AppLayout';
import MobileAppLayout from 'components/layout/MobileAppLayout';
import MobileAppClearLayout from 'components/layout/MobileAppClearLayout';
import MobileAppSafeLayout from 'components/layout/MobileAppSafeLayout';
import Message from 'components/common/Message';
import faIR from 'antd/lib/locale/fa_IR';

import AppClearLayout from 'components/layout/AppClearLayout';
import MatomoTracking from 'components/MatomoTracking';
// import FirebaseNotification from 'components/FireBaseNotification';

import {ConfigProvider} from 'antd';
// import TagManager from 'react-gtm-module'

import 'global-styles/_style_importer.scss'
import 'react-loading-skeleton/dist/skeleton.css'
import Error from './error';

import i18n from '../i18n';
import {I18nextProvider, useTranslation} from 'react-i18next';
import _ from "lodash";

const Pingi = props => {
    const {t} = useTranslation()
    const UserState = useSelector((state) => state.User.info);
    const ThemeState = useSelector((state) => state.Theme);
    const router = useRouter()
    const store = useStore();
    const [VPNDetected, setVPNDetected] = useState(false)
    const isProd = process.env.NEXT_PUBLIC_APP_ENV === 'production'

    const tagManagerArgs = {
        gtmId: 'GTM-KQL9JX5'
    }

    const themes = {
        light: '/antd/ant-d.light.css',
        dark: '/antd/ant-d.dark.css',
    };

    const retrieveDefaultTheme = () => {
        try {
            return Cookies.get('theme') ?? 'dark'
        } catch (e) {
            return 'dark'
        }
    }


    const detectVPN = async () => {
        try {
            let response = await getApiService(Api.DETECTOR, false);
            if (response.success === false) {

            } else {
                let {data} = response
                // pulls value of country from the string using regex
                const findCountryValue = (text) => {
                    const regex = /country\s*:\s*([A-Z]{2})/i;
                    const match = text.match(regex);
                    return match ? match[1] : null;
                }
                if (findCountryValue(data.results) !== 'IR') {
                    let vpn_detected = Cookies.get('vpn_detected') ?? false
                    if (vpn_detected === false) {
                        setVPNDetected(true)
                        Message({
                            type: 'warning',
                            text: t('close_vpn_please'),
                            duration: 7
                        })
                        Cookies.set('vpn_detected', 'true', {path: '/', sameSite: 'lax'});
                    }
                }
            }
        } catch (e) {
            // Nothing
        }
    }

    useEffect(() => {
        try {
            // if (typeof window !== 'undefined') {
            //     try {
            //         hotjar.initialize('3599234', '6');
            //     } catch (e) {
            //         console.log(e)
            //     }
            // }
            // if (typeof document !== "undefined") {
            //     TagManager.initialize(tagManagerArgs)
            // }

            detectVPN().then()
        } catch (e) {
            // Do nothing
        }
    }, [])

    /**
     * Information that was returned  from 'getInitialProps' are stored in the props i.e. pageProps
     */
    let {Component, pageProps, layoutClass} = props;
    let CurrentLayout = (ThemeState.mobileView)
        // ? (pageProps?.layout === 'clear' ? MobileAppClearLayout : MobileAppLayout)
        // : (pageProps?.layout === 'clear' ? AppClearLayout : AppLayout);
        ? (_.isNull(UserState) ? MobileAppClearLayout : MobileAppLayout)
        : (_.isNull(UserState) ? AppClearLayout : AppLayout);
    Component = !!pageProps.error ? Error : Component;

    if (UserState?.pk && UserState.pk === 26880)
        CurrentLayout = MobileAppSafeLayout

    let toRender = <>
        <Head>
            <meta name={'viewport'}
                  content={'width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0,viewport-fit=cover'}/>
        </Head>
        {isProd && <MatomoTracking />}
        {/*<FirebaseNotification/>*/}
        <ConfigProvider direction={'rtl'} locale={faIR}>
            <ThemeSwitcherProvider defaultTheme={retrieveDefaultTheme()}
                                   insertionPoint={process.browser ? document.getElementById('jss-insertion-point') : null}
                                   themeMap={themes}>
                <RequirementSystem {...props}>
                    <I18nextProvider i18n={i18n}>
                        <CurrentLayout clearBackground={pageProps?.clearBackground ?? false}
                                       disableFooter={pageProps?.disableFooter ?? false}
                                       disableNavigation={pageProps?.disableNavigation ?? false}
                                       disableHeaderNavigation={pageProps?.disableHeaderNavigation ?? false}
                                       disableHeader={pageProps?.disableHeader ?? false}
                                       disableDrawer={pageProps?.disableDrawer ?? false}
                                       showMenu={pageProps?.showMenu ?? false}
                                       showBack={pageProps?.showBack ?? true}
                                       forceBack={pageProps?.forceBack ?? true}
                                       activeMenu={pageProps?.activeMenu ?? ''}
                                       pageTitle={pageProps?.pageTitle ?? ''}
                                       layoutClass={pageProps?.layoutClass ?? false}
                                       currentPath={router.pathname}>
                            <Component {...pageProps} currentPath={router.pathname}/>
                        </CurrentLayout>
                    </I18nextProvider>
                </RequirementSystem>
            </ThemeSwitcherProvider>
        </ConfigProvider>
    </>;

    return <PersistGate persistor={store.__persistor}>
        {toRender}
    </PersistGate>

};

/**
 * withRedux wrapper that passes the store to the App Component
 */
export default wrapper.withRedux(Pingi);
